import { useEffect, useState } from "react";

import { ModalRight } from "components/ModalRight";
import { QuantityCounterService } from "./QuantityCounterService";
import { CardChecklistDetail } from "components/CardChecklistDetail";
import { ModalObservationDetail } from "components/ModalObservationDetail";

import { ServiceDTO } from "dtos/ServiceDTO";

import { useToast } from "hooks/toast";
import { useSelectedService } from "hooks/budget/selectedServices";

import * as S from "./styles";

type CardSelectedServicesProps = {
  data: ServiceDTO;
  onIncrement: (id: number, quantity: number) => void;
  disabled?: boolean;
};

export function CardSelectedServices({
  data,
  onIncrement,
  disabled,
}: CardSelectedServicesProps) {
  const { addToast } = useToast();
  const { totalAmountOfServices } = useSelectedService();

  const [isOpenObservationDetail, setIsOpenObservationDetail] = useState(false);
  const [isOpenCheckListDetail, setIsOpenCheckListDetail] = useState(false);
  const [quantityService, setQuantityService] = useState(0);

  useEffect(() => {
    setQuantityService(data.quantity);
  }, [data.quantity]);

  function handleDecrementQuantityService() {
    if (quantityService <= 1 || disabled) {
      return;
    }

    setQuantityService(oldState => oldState - 1);
    const result = quantityService - 1;
    onIncrement(data.id, result);
  }

  function handleIncrementQuantityService() {
    if (disabled) {
      return;
    }

    if (totalAmountOfServices >= 15) {
      addToast({
        title: 'Limite de serviços atingido.',
        description: 'Você atingiu o limite máximo de 15 serviços neste orçamento.',
        type: 'warning',
      });

      return;
    }

    setQuantityService(oldState => oldState + 1);
    const result = quantityService + 1;
    onIncrement(data.id, result);
  }

  function handleToggle() {
    setIsOpenObservationDetail(!isOpenObservationDetail);
  }

  function handleToggleModalCheckListDetail() {
    setIsOpenCheckListDetail(!isOpenCheckListDetail);
  }

  return (
    <>
      <ModalRight
        isOpen={isOpenObservationDetail}
        handleToggleOpen={handleToggle}
      >
        <ModalObservationDetail
          observation={data.description || ""}
          handleGoBack={handleToggle}
        />
      </ModalRight>

      <ModalRight
        isOpen={isOpenCheckListDetail}
        handleToggleOpen={handleToggleModalCheckListDetail}
      >
        <CardChecklistDetail
          nameCheckList={
            data?.serviceChecklist ? data?.serviceChecklist[0]?.name : ""
          }
          checklistRegisters={
            data?.serviceChecklist ? data?.serviceChecklist[0]?.registers : []
          }
          handleGoBack={handleToggleModalCheckListDetail}
        />
      </ModalRight>

      <S.Container>
        <header>
          <S.Title>{data.service.name}</S.Title>
          <S.Title>{data.formattedTotal}</S.Title>
        </header>

        {data.equipment.name ? (
          <S.Description>
            {data.equipment.name}{" "}
            {!!data.equipmentType?.name && data.equipmentType.name}{" "}
            {!!data.capacity?.name && data.capacity.name}{" "}
            {!!data?.brand && ` | Marca: ${data.brand} `}
          </S.Description>
        ) : (
          <S.Description>Sem equipamento cadastrado.</S.Description>
        )}

        <S.Description>
          {!!data.runtime?.time &&
            !!data.runtime?.extension &&
            `Execução: ${data.runtime.time} ${data.runtime.extension},`}
          {!!data.warranty?.time &&
            !!data.warranty?.extension &&
            ` Garantia: ${data.warranty.time} ${data.warranty.extension} `}

          {!!data.description && (
            <>
              <br />
              <S.ObservationButton type="button" onClick={() => handleToggle()}>
                Detalhamento do Serviço
              </S.ObservationButton>
            </>
          )}

          <br />

          {data?.serviceChecklist && data?.serviceChecklist?.length > 0 && (
            <S.ObservationButton
              type="button"
              onClick={() => handleToggleModalCheckListDetail()}
            >
              Detalhamento dos Registros
            </S.ObservationButton>
          )}
        </S.Description>

        <S.WrapperContent>
          <S.TextDetail>Quantidade:</S.TextDetail>

          <QuantityCounterService
            initialValue={data.quantity}
            hasMaxCount={totalAmountOfServices > 15}
            disabled={disabled}
            onIncrement={handleIncrementQuantityService}
            onDecrement={handleDecrementQuantityService}
            />
        </S.WrapperContent>
        {data?.serviceChecklist && data?.serviceChecklist?.length > 0 && (
          <S.Checklist>
            <p>{data?.serviceChecklist?.length} checklist(s) vinculado(s)</p>
          </S.Checklist>
        )}
      </S.Container>
    </>
  );
}
